<div>
  <h1 class="modal-head-text">{{config.title}}</h1>
  <div class="email-modification-div">
    <app-email-verification-form class="email-verification-form-container"></app-email-verification-form>
    <button mat-flat-button class="button-forward primary verification-button" (click)="updateEmailid()" *ngIf="showActionButton()">Verify your
      mail id
    </button>
  </div>
</div>
